import { useEffect } from 'react';
import { useLocation, matchPath } from 'react-router-dom';
import { trackPageLoad } from 'utils/tracking';
import { TRACKING_ROUTE_CONFIG } from 'utils/constants/trackingRoutes';

const TrackPageLoad = () => {
  const location = useLocation();

  useEffect(() => {
    const currentRoute = TRACKING_ROUTE_CONFIG.find(route => 
      matchPath({ path: route.path, end: true }, location.pathname)
    );

    if (currentRoute) {
      trackPageLoad(currentRoute.pageName);
    }
  }, [location.pathname]);
  return null;
};

export default TrackPageLoad;
